import { render, staticRenderFns } from "./StartingOrderFormComponent.vue?vue&type=template&id=dc2f1afc"
import script from "./StartingOrderFormComponent.vue?vue&type=script&lang=js"
export * from "./StartingOrderFormComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports